import { Checkbox, Divider, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Paper, Select, TextField, Typography, Button, useMediaQuery, useTheme } from '@material-ui/core';
import React, { useGlobal } from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionSubTitle } from '../../components/SectionSubTitle';
import { SectionTitle } from '../../components/SectionTitle';
import { IGlobalState } from '../../states/GlobalState';
import { globalStyles } from '../../style/GlobalStyles';
import { SimulazioniSrlDataClass } from '../../states/SimulazioneSrlState';
import data from '../../json/tabelle.json';
import { ADD_COM_IRPEF_PercDataClass, ALIQUOTA_GESTIONE_SEPARATA_PercDataClass, ARTIG_COMM_PercDataClass, RILEVANZA_FISCALE_DEI_DIVIDENDI_PercDataClass } from '../../types/types';
import { regioni } from "../../utils/costanti";
import { API_elaboraConvSrl } from '../../utils/functions';
import { breakpoint } from '../../types/constants';

export type SimulazioniExtSrlInputProps = SimulazioniSrlInputProps & {
    global: IGlobalState;
}

export type SimulazioniSrlInputProps = {
    state: SimulazioniSrlDataClass;
    handleChange?: any;
    username?: string;
    handleOpenLoadData?: any;
}

export default function DatiSimulazioniSrl(props: SimulazioniExtSrlInputProps) {
    const theme = useTheme();
    const gClasses = globalStyles();
    const action = "changeDatiSimulazioniSrl";
    // const [global] = useGlobal<IGlobalState>();
    const mobile = useMediaQuery(theme.breakpoints.down(breakpoint));
    const { state } = props;
    const marginTop = mobile ? '0' : '12px';

    const handleChange = (e: any) => {
        console.log('on change 2')
        let { name, value } = e.target;
        props.handleChange(action, name, value);
    }

    const handleChangeChecked = (e: any) => {
        let { name, checked } = e.target;
        props.handleChange(action, name, checked);
        API_elaboraConvSrl(props, props.global, name, checked, action, true);
    }

    const handleChangeSelect = (e: any) => {
        handleChange(e);
        let { name, value } = e.target;
        API_elaboraConvSrl(props, props.global, name, value, action, true);
    };

    const handleBlur = (e: any) => {
        // API_elaboraConvSrl(props, global);
    }

    const RILEVANZA_FISCALE_DEI_DIVIDENDI = data.RILEVANZA_FISCALE_DEI_DIVIDENDI as RILEVANZA_FISCALE_DEI_DIVIDENDI_PercDataClass;

    const ALIQUOTA_GESTIONE_SEPARATA = data.ALIQUOTA_GESTIONE_SEPARATA as ALIQUOTA_GESTIONE_SEPARATA_PercDataClass;

    const ARTIG_COMM = data.ARTIG_COMM as ARTIG_COMM_PercDataClass;

    const ADD_COM_IRPEF = data.ADD_COM_IRPEF as ADD_COM_IRPEF_PercDataClass;

    let error = state.datiSimulazioniSrl.G48 === undefined || state.datiSimulazioniSrl.G48 === "";

    return (
        <React.Fragment>
            <Paper className={gClasses.mainPaper} >
                <SectionTitle text="Società"></SectionTitle>
                <Grid container spacing={3}>
                    <Grid item xs={12} lg={4}>
                        <TextField
                            name="G48"
                            label="Ragione sociale"
                            error={error}
                            helperText={error ? "Campo obbligatorio" : ""}
                            value={state.datiSimulazioniSrl.G48}
                            className={gClasses.longTextField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            margin="normal"
                            onChange={handleChange} 
                            // onBlur={handleBlur}
                        />
                    </Grid>
                    <Grid item xs={12} lg={4}>
                        <TextField
                            name="IDSocieta"
                            label="Identificativo"
                            value={state.datiSimulazioniSrl.IDSocieta}
                            className={gClasses.longTextFieldReadOnly}
                            InputLabelProps={{
                                shrink: true,
                                disabled: true
                            }}
                            inputProps={{tabIndex: -1}}
                            // style={{ borderBottom: '0px' }}
                            margin="normal"
                        />
                    </Grid>                                       
                    <Grid item xs={12} lg={4} style={{marginTop: marginTop}}>
                        <Button variant="contained" color="primary"  
                            onClick={props.handleOpenLoadData} 
                            disabled={state.datiSimulazioniSrl.G48 === "" || state.datiSimulazioniSrl.G48 === null}
                        >
                            Carica dati
                        </Button>
                    </Grid>                   
                </Grid>
                <Grid container spacing={3}>
                    <Grid item>
                        <NumberField
                            name="K62"
                            label="Utile di bilancio"
                            value={state.datiSimulazioniSrl.K62}
                            className={gClasses.textField}
                            onChange={handleChange} 
                            // onBlur={handleBlur}
                            tooltip="senza compensi agli amministratori e al lordo dell'IRES"
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="K63"
                            label="Variazioni fiscali in aumento"
                            value={state.datiSimulazioniSrl.K63}
                            className={gClasses.textField}
                            onChange={handleChange} 
                            // onBlur={handleBlur}
                        />
                    </Grid>
                    <Grid item >
                        <NumberField
                            name="K64"
                            label="Variazioni fiscali in diminuzione"
                            value={state.datiSimulazioniSrl.K64}
                            className={gClasses.textField}
                            onChange={handleChange} 
                            // onBlur={handleBlur}
                        />
                    </Grid>
                    <Grid item >
                        <NumberField
                            name="D65"
                            label="Aliquota IRES"
                            value={state.datiSimulazioniSrl.D65}
                            className={gClasses.textField}
                            symbol={"%"}
                            onChange={handleChange} 
                            // onBlur={handleBlur}
                        />
                    </Grid>
                </Grid>
                <SectionTitle text="Soci"></SectionTitle>
                <Grid container spacing={3}>
                    <Grid item>
                        <TextField
                            name="C52"
                            label="1° Socio"
                            value={state.datiSimulazioniSrl.C52}
                            className={gClasses.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            margin="normal"
                            onChange={handleChange} 
                            // onBlur={handleBlur}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="K52"
                            label="Quota di partec. agli utili"
                            value={state.datiSimulazioniSrl.K52}
                            className={gClasses.textField}
                            // forcedError={(GestParseFloatNaN(state.datiSimulazioniSrl.K52)
                            //     + GestParseFloatNaN(state.datiSimulazioniSrl.K53)
                            //     + GestParseFloatNaN(state.datiSimulazioniSrl.K54)) > 100}
                            // forcedErrorMessage={"Errore: valore quote > 100"}
                            margin="normal"
                            onChange={handleChange} 
                            // onBlur={handleBlur}
                            min={0}
                            max={100}
                            symbol={"%"}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item>
                        <TextField
                            name="C53"
                            label="2° Socio"
                            value={state.datiSimulazioniSrl.C53}
                            className={gClasses.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            margin="normal"
                            onChange={handleChange} 
                            onBlur={handleBlur}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="K53"
                            label="Quota di partec. agli utili"
                            value={state.datiSimulazioniSrl.K53}
                            className={gClasses.textField}
                            onChange={handleChange} 
                            onBlur={handleBlur}
                            // forcedError={(GestParseFloatNaN(state.datiSimulazioniSrl.K52)
                            //     + GestParseFloatNaN(state.datiSimulazioniSrl.K53)
                            //     + GestParseFloatNaN(state.datiSimulazioniSrl.K54)) > 100}
                            // forcedErrorMessage={"Errore: valore quote > 100"}
                            margin="normal"
                            min={0}
                            max={100}
                            symbol={"%"}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item>
                        <TextField
                            name="C54"
                            label="3° Socio"
                            value={state.datiSimulazioniSrl.C54}
                            className={gClasses.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            margin="normal"
                            onChange={handleChange} 
                            onBlur={handleBlur}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="K54"
                            label="Quota di partec. agli utili"
                            value={state.datiSimulazioniSrl.K54}
                            className={gClasses.textField}
                            onChange={handleChange} 
                            onBlur={handleBlur}
                            // forcedError={(GestParseFloatNaN(state.datiSimulazioniSrl.K52)
                            //     + GestParseFloatNaN(state.datiSimulazioniSrl.K53)
                            //     + GestParseFloatNaN(state.datiSimulazioniSrl.K54)) > 100}
                            // forcedErrorMessage={"Errore: valore quote > 100"}
                            margin="normal"
                            min={0}
                            max={100}
                            symbol={"%"}
                        />
                    </Grid>
                </Grid>
                <Typography color="error" variant="h6">{state.datiSimulazioniSrl.L52}</Typography>
            </Paper>
            <Paper className={gClasses.mainPaper}>
                <SectionSubTitle text="1° Simulazione - società non trasparente - nessun compenso agli amministratori - nessun dividendo"></SectionSubTitle>
                <Typography variant="subtitle2">Nessun parametro necessario</Typography>
            </Paper>
            <Paper className={gClasses.mainPaper}>
                <SectionSubTitle text="2° Simulazione - società non trasparente - compenso agli amministratori - nessun dividendo"></SectionSubTitle>
                <NumberField
                    name="D72"
                    label="Totale compensi"
                    value={state.datiSimulazioniSrl.D72}
                    className={gClasses.textField}
                    onChange={handleChange} 
                    onBlur={handleBlur}
                    margin="normal"
                />
                <Typography className={gClasses.diCui} variant="h6">di cui:</Typography>
                <Grid container spacing={3}>
                    <Grid item>
                        <TextField
                            name="C52"
                            label="1° Socio"
                            value={state.datiSimulazioniSrl.C52}
                            className={gClasses.textFieldReadOnly}
                            InputLabelProps={{
                                shrink: true,
                                disabled: true
                            }}
                            inputProps={{tabIndex: -1}}
                            margin="normal"
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="G74"
                            label="Compenso"
                            value={state.datiSimulazioniSrl.G74}
                            className={gClasses.textField}
                            onChange={handleChange} 
                            onBlur={handleBlur}
                            margin="normal"
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item>
                        <TextField
                            name="C53"
                            label="2° Socio"
                            value={state.datiSimulazioniSrl.C53}
                            className={gClasses.textFieldReadOnly}
                            InputLabelProps={{
                                shrink: true,
                                disabled: true
                            }}
                            inputProps={{tabIndex: -1}}
                            margin="normal"
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="G75"
                            label="Compenso"
                            value={state.datiSimulazioniSrl.G75}
                            className={gClasses.textField}
                            onChange={handleChange} 
                            onBlur={handleBlur}
                            margin="normal"
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={3}>
                    <Grid item>
                        <TextField
                            name="C54"
                            label="3° Socio"
                            value={state.datiSimulazioniSrl.C54}
                            className={gClasses.textFieldReadOnly}
                            InputLabelProps={{
                                shrink: true,
                                disabled: true
                            }}
                            inputProps={{tabIndex: -1}}
                            margin="normal"
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="G76"
                            label="Compenso"
                            value={state.datiSimulazioniSrl.G76}
                            className={gClasses.textField}
                            onChange={handleChange} 
                            onBlur={handleBlur}
                            margin="normal"
                        />
                    </Grid>
                </Grid>
                <Typography color="error" variant="h6">{state.datiSimulazioniSrl.H74}</Typography>
            </Paper>
            <Paper className={gClasses.mainPaper}>
                <SectionSubTitle text="3° simulazione - società non trasparente - nessun compenso agli amministratori - distribuzione dividendi"></SectionSubTitle>
                <NumberField
                    name="D83"
                    label="Totale dividendi"
                    value={state.datiSimulazioniSrl.D83}
                    className={gClasses.textField}
                    onChange={handleChange} 
                    onBlur={handleBlur}
                    margin="normal"
                />
            </Paper>
            <Paper className={gClasses.mainPaper}>
                <SectionSubTitle text="4° simulazione - società non trasparente - compenso agli amministratori e distribuzione dividendi"></SectionSubTitle>
                <Grid container spacing={3}>
                    <Grid item>
                        <NumberField
                            name="D88"
                            label="Totale dividendi"
                            value={state.datiSimulazioniSrl.D88}
                            className={gClasses.textField}
                            onChange={handleChange} 
                            onBlur={handleBlur}
                            margin="normal"
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item>
                        <NumberField
                            name="D89"
                            label="Totale compensi"
                            value={state.datiSimulazioniSrl.D89}
                            className={gClasses.textField}
                            onChange={handleChange} 
                            onBlur={handleBlur}
                            margin="normal"
                        />
                    </Grid>
                </Grid>
                <Typography className={gClasses.diCui} variant="h6">di cui:</Typography>
                <Grid container spacing={3}>
                    <Grid item>
                        <TextField
                            name="C52"
                            label="1° Socio"
                            value={state.datiSimulazioniSrl.C52}
                            className={gClasses.textFieldReadOnly}
                            InputLabelProps={{
                                shrink: true,
                                disabled: true
                            }}
                            inputProps={{tabIndex: -1}}
                            margin="normal"
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="G91"
                            label="Compenso"
                            value={state.datiSimulazioniSrl.G91}
                            className={gClasses.textField}
                            onChange={handleChange} 
                            onBlur={handleBlur}
                            margin="normal"
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={3}>
                    <Grid item>
                        <TextField
                            name="C53"
                            label="2° Socio"
                            value={state.datiSimulazioniSrl.C53}
                            className={gClasses.textFieldReadOnly}
                            InputLabelProps={{
                                shrink: true,
                                disabled: true
                            }}
                            inputProps={{tabIndex: -1}}
                            margin="normal"
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="G92"
                            label="Compenso"
                            value={state.datiSimulazioniSrl.G92}
                            className={gClasses.textField}
                            onChange={handleChange} 
                            onBlur={handleBlur}
                            margin="normal"
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item>
                        <TextField
                            name="C54"
                            label="3° Socio"
                            value={state.datiSimulazioniSrl.C54}
                            className={gClasses.textFieldReadOnly}
                            InputLabelProps={{
                                shrink: true,
                                disabled: true
                            }}
                            inputProps={{tabIndex: -1}}
                            margin="normal"
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="G93"
                            label="Compenso"
                            value={state.datiSimulazioniSrl.G93}
                            className={gClasses.textField}
                            onChange={handleChange} 
                            onBlur={handleBlur}
                            margin="normal"
                        />
                    </Grid>
                </Grid>
                <Typography color="error" variant="h6">{state.datiSimulazioniSrl.H91}</Typography>
            </Paper>
            <Paper className={gClasses.mainPaper}>
                <SectionSubTitle text="5° simulazione - società trasparente - nessun compenso agli amministratori"></SectionSubTitle>
                <Typography variant="subtitle2">Nessun parametro necessario</Typography>
            </Paper>
            <Paper className={gClasses.mainPaper}>
                <SectionSubTitle text="6° simulazione - società trasparente - compenso agli amministratori"></SectionSubTitle>
                <NumberField
                    name="D102"
                    label="Totale compensi"
                    value={state.datiSimulazioniSrl.D102}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <Typography className={gClasses.diCui} variant="h6">di cui:</Typography>
                <Grid container spacing={3}>
                    <Grid item>
                        <TextField
                            name="C52"
                            label="1° Socio"
                            value={state.datiSimulazioniSrl.C52}
                            className={gClasses.textFieldReadOnly}
                            InputLabelProps={{
                                shrink: true,
                                disabled: true
                            }}
                            inputProps={{tabIndex: -1}}
                            margin="normal"
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="G104"
                            label="Compenso"
                            value={state.datiSimulazioniSrl.G104}
                            className={gClasses.textField}
                            onChange={handleChange} onBlur={handleBlur}
                            margin="normal"
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item>
                        <TextField
                            name="C53"
                            label="2° Socio"
                            value={state.datiSimulazioniSrl.C53}
                            className={gClasses.textFieldReadOnly}
                            InputLabelProps={{
                                shrink: true,
                                disabled: true
                            }}
                            inputProps={{tabIndex: -1}}
                            margin="normal"
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="G105"
                            label="Compenso"
                            value={state.datiSimulazioniSrl.G105}
                            className={gClasses.textField}
                            onChange={handleChange} onBlur={handleBlur}
                            margin="normal"
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item>
                        <TextField
                            name="C54"
                            label="3° Socio"
                            value={state.datiSimulazioniSrl.C54}
                            className={gClasses.textFieldReadOnly}
                            InputLabelProps={{
                                shrink: true,
                                disabled: true
                            }}
                            inputProps={{tabIndex: -1}}
                            margin="normal"
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="G106"
                            label="Compenso"
                            value={state.datiSimulazioniSrl.G106}
                            className={gClasses.textField}
                            onChange={handleChange} onBlur={handleBlur}
                            margin="normal"
                        />
                    </Grid>
                </Grid>
                <Typography color="error" variant="h6">{state.datiSimulazioniSrl.H104}</Typography>

            </Paper>
            <Paper className={gClasses.mainPaper}>
                <SectionSubTitle text="Dividendi"></SectionSubTitle>
                <FormControl className={gClasses.formControl} disabled={state.datiSimulazioniSrl.J111}>
                    <InputLabel htmlFor="B111">Rilevanza fiscale dei dividendi</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.datiSimulazioniSrl.E111}
                        onChange={handleChangeSelect}
                        inputProps={{ name: 'E111', id: 'E111' }}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        <MenuItem value={RILEVANZA_FISCALE_DEI_DIVIDENDI.perc_1}>{RILEVANZA_FISCALE_DEI_DIVIDENDI.perc_1}%</MenuItem>
                        <MenuItem value={RILEVANZA_FISCALE_DEI_DIVIDENDI.perc_2}>{RILEVANZA_FISCALE_DEI_DIVIDENDI.perc_2}%</MenuItem>
                        <MenuItem value={RILEVANZA_FISCALE_DEI_DIVIDENDI.perc_3}>{RILEVANZA_FISCALE_DEI_DIVIDENDI.perc_3}%</MenuItem>
                    </Select>
                </FormControl>
                <FormControlLabel className={gClasses.bottomControlLabel}
                    disabled={state.datiSimulazioniSrl.E111 !== 0}
                    labelPlacement="start"
                    control={
                        <Checkbox
                            checked={state.datiSimulazioniSrl.J111}
                            onChange={handleChangeChecked}
                            name='J111'
                            value={state.datiSimulazioniSrl.J111}
                            inputProps={{ 'aria-label': 'primary checkbox' }} 
                        />
                    }
                    label="Tutti i dividendi ad imposta sostitutiva 26%"
                />
            </Paper>

            <SectionTitle primary={true} text="Soci - altri dati"></SectionTitle>
            <Paper className={gClasses.mainPaper}>
                <SectionTitle text="1° Socio"></SectionTitle>
                <TextField
                    name="C52"
                    label="Nome socio"
                    value={state.datiSimulazioniSrl.C52}
                    className={gClasses.textFieldReadOnly}
                    InputLabelProps={{
                        shrink: true,
                        disabled: true
                    }}
                    inputProps={{tabIndex: -1}}
                    margin="normal"
                />
                <SectionSubTitle text="Redditi non provenienti da questa società"></SectionSubTitle>
                <NumberField
                    name="E118"
                    label="Pensione"
                    value={state.datiSimulazioniSrl.E118}
                    className={gClasses.textField}
                    onChange={handleChange} 
                    onBlur={handleBlur}
                />
                <NumberField
                    name="E119"
                    label="Lav. dipendente e assim."
                    value={state.datiSimulazioniSrl.E119}
                    className={gClasses.textField}
                    onChange={handleChange} 
                    onBlur={handleBlur}
                />
                <NumberField
                    name="E120"
                    label="Assimilati lav. dipendente"
                    value={state.datiSimulazioniSrl.E120}
                    className={gClasses.textField}
                    onChange={handleChange} 
                    onBlur={handleBlur}
                />
                <NumberField
                    name="E121"
                    label="Impr. minore/ Lav. auton."
                    value={state.datiSimulazioniSrl.E121}
                    className={gClasses.textField}
                    onChange={handleChange} 
                    onBlur={handleBlur}
                />
                <NumberField
                    name="E122"
                    label="Diversi lettere i) e l)"
                    value={state.datiSimulazioniSrl.E122}
                    className={gClasses.textField}
                    onChange={handleChange} 
                    onBlur={handleBlur}
                />
                <NumberField
                    name="E123"
                    label="Fabbricati locati"
                    value={state.datiSimulazioniSrl.E123}
                    className={gClasses.textField}
                    onChange={handleChange} 
                    onBlur={handleBlur}
                />
                <NumberField
                    name="E124"
                    label="Altri"
                    value={state.datiSimulazioniSrl.E124}
                    className={gClasses.textField}
                    onChange={handleChange} 
                    onBlur={handleBlur}
                />
                <NumberField
                    name="E125"
                    label="Abitazione principale"
                    value={state.datiSimulazioniSrl.E125}
                    className={gClasses.textField}
                    onChange={handleChange} 
                    onBlur={handleBlur}
                />
                <NumberField
                    name="E127"
                    label="Redditi a cedolare secca"
                    value={state.datiSimulazioniSrl.E127}
                    className={gClasses.textField}
                    onChange={handleChange} 
                    onBlur={handleBlur}
                />
                <SectionSubTitle text="Dati individuali"></SectionSubTitle>
                <Typography variant="h6">Familiari a carico</Typography>
                <Grid container spacing={1} alignItems="flex-end" xs={12}>
                    <Grid item xs={6} md={4}>
                        <FormControlLabel className={gClasses.bottomControlLabel}
                            labelPlacement="end"
                            control={
                                <Checkbox
                                    checked={state.datiSimulazioniSrl.H119}
                                    name='H119'
                                    value={state.datiSimulazioniSrl.H119}
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                    onChange={handleChangeChecked}
                                />
                            }
                            label="Coniuge"
                        />
                    </Grid>
                    <Grid item xs={6} md={4}>
                        <FormControl className={gClasses.formControl}>
                            <InputLabel htmlFor="I119">Figli n.</InputLabel>
                            <Select
                                className={gClasses.select}
                                value={state.datiSimulazioniSrl.J119}
                                inputProps={{ name: 'J119' }}
                                onChange={handleChangeSelect}
                            >
                                <MenuItem value={0}>Non definito</MenuItem>
                                <MenuItem value={1}>1</MenuItem>
                                <MenuItem value={2}>2</MenuItem>
                                <MenuItem value={3}>3</MenuItem>
                                <MenuItem value={4}>4</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6} md={4}>
                        <FormControl className={gClasses.formControl}>
                            <InputLabel htmlFor="K119">%</InputLabel>
                            <Select
                                className={gClasses.select}
                                value={state.datiSimulazioniSrl.L119}
                                inputProps={{ name: 'L119' }}
                                onChange={handleChangeSelect}
                            >
                                <MenuItem value={0}>Non definito</MenuItem>
                                <MenuItem value={50}>50%</MenuItem>
                                <MenuItem value={100}>100%</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container spacing={1} alignItems="flex-end">
                    <Grid item xs={6} md={4}>
                        <NumberField
                            name="L121"
                            label="Oneri deducibili"
                            value={state.datiSimulazioniSrl.L121}
                            className={gClasses.textField}
                            onChange={handleChange} 
                            onBlur={handleBlur}
                            tooltip="Oneri deducibili diversi dai contributi IVS"
                        />
                    </Grid>
                    <Grid item xs={6} md={4}>
                        <NumberField
                            name="L122"
                            label="Detrazioni per oneri e altre detrazioni"
                            value={state.datiSimulazioniSrl.L122}
                            className={gClasses.textField}
                            onChange={handleChange} 
                            onBlur={handleBlur}
                        />
                    </Grid>
                    <Grid item xs={6} md={4}>
                        <FormControl className={gClasses.formControl}>
                            <InputLabel htmlFor="K120">Aliquota Gestione Separata</InputLabel>
                            <Select
                                className={gClasses.select}
                                value={state.datiSimulazioniSrl.N120}
                                onChange={handleChangeSelect}
                                inputProps={{ name: 'N120', id: 'N120' }}
                            >
                                <MenuItem value={0}>Non definito</MenuItem>
                                <MenuItem value={ALIQUOTA_GESTIONE_SEPARATA.perc_1}>{ALIQUOTA_GESTIONE_SEPARATA.perc_1}%</MenuItem>
                                <MenuItem value={ALIQUOTA_GESTIONE_SEPARATA.perc_2}>{ALIQUOTA_GESTIONE_SEPARATA.perc_2}%</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container spacing={1} alignItems="flex-end">
                    <Grid item xs={6} md={4}>
                        <FormControlLabel className={gClasses.bottomControlLabel}
                            labelPlacement="end"
                            control={
                                <Checkbox
                                    checked={state.datiSimulazioniSrl.J124}
                                    name='J124'
                                    value={state.datiSimulazioniSrl.J124}
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                    onChange={handleChangeChecked}
                                />
                            }
                            label="Soggetto a contribuzione IVS"
                        />
                    </Grid>
                    <Grid item xs={6} md={4}>
                        <NumberField
                            name="J125"
                            label="Ulteriori redditi d'impresa per IVS"
                            value={state.datiSimulazioniSrl.J125}
                            className={gClasses.textField}
                            onChange={handleChange} 
                            onBlur={handleBlur}
                        />
                    </Grid>
                    <Grid item xs={6} md={4}>
                        <FormControl className={gClasses.formControl}>
                            <InputLabel htmlFor="K124">Artig./Comm.</InputLabel>
                            <Select
                                className={gClasses.select}
                                value={state.datiSimulazioniSrl.M124}
                                onChange={handleChangeSelect}
                                inputProps={{ name: 'M124', id: 'M124' }}
                            >
                                <MenuItem value={"Non definito"}>Non definito</MenuItem>
                                <MenuItem value={ARTIG_COMM.value_1}>{ARTIG_COMM.desc_1}</MenuItem>
                                <MenuItem value={ARTIG_COMM.value_2}>{ARTIG_COMM.desc_2}</MenuItem>
                                <MenuItem value={ARTIG_COMM.value_3}>{ARTIG_COMM.desc_3}</MenuItem>
                                <MenuItem value={ARTIG_COMM.value_4}>{ARTIG_COMM.desc_4}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container spacing={1} alignItems="flex-end">
                    <Grid item xs={6} md={4}>
                        <FormControl className={gClasses.formControl}>
                            <InputLabel htmlFor="G126">Regione di residenza</InputLabel>
                            <Select
                                className={gClasses.select}
                                value={state.datiSimulazioniSrl.J126}
                                inputProps={{ name: 'J126', id: 'J126' }}
                                onChange={handleChangeSelect}
                            >
                                <MenuItem value={0}>Non definito</MenuItem>
                                {regioni.map(regione => (
                                    <MenuItem key={regione.codice} value={regione.codice}>{regione.descrizione}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6} md={4}>
                        <FormControl className={gClasses.formControl}>
                            <InputLabel htmlFor="K126">Add. Com. Irpef</InputLabel>
                            <Select
                                className={gClasses.select}
                                value={state.datiSimulazioniSrl.M126}
                                inputProps={{ name: 'M126' }}
                                onChange={handleChangeSelect}
                            >
                                <MenuItem value={ADD_COM_IRPEF.perc_1}>{ADD_COM_IRPEF.perc_1}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_2}>{ADD_COM_IRPEF.perc_2}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_3}>{ADD_COM_IRPEF.perc_3}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_4}>{ADD_COM_IRPEF.perc_4}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_5}>{ADD_COM_IRPEF.perc_5}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_6}>{ADD_COM_IRPEF.perc_6}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_7}>{ADD_COM_IRPEF.perc_7}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_8}>{ADD_COM_IRPEF.perc_8}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_9}>{ADD_COM_IRPEF.perc_9}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_10}>{ADD_COM_IRPEF.perc_10}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_11}>{ADD_COM_IRPEF.perc_11}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_12}>{ADD_COM_IRPEF.perc_12}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_13}>{ADD_COM_IRPEF.perc_13}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_14}>{ADD_COM_IRPEF.perc_14}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_15}>{ADD_COM_IRPEF.perc_15}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_16}>{ADD_COM_IRPEF.perc_16}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_17}>{ADD_COM_IRPEF.perc_17}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_18}>{ADD_COM_IRPEF.perc_18}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_19}>{ADD_COM_IRPEF.perc_19}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_20}>{ADD_COM_IRPEF.perc_20}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_21}>{ADD_COM_IRPEF.perc_21}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_22}>{ADD_COM_IRPEF.perc_22}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_23}>{ADD_COM_IRPEF.perc_23}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_24}>{ADD_COM_IRPEF.perc_24}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_25}>{ADD_COM_IRPEF.perc_25}%</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </Paper>
            <Divider></Divider>
            <Paper className={gClasses.mainPaper}>
                <SectionTitle text="2° Socio"></SectionTitle>
                <TextField
                    name="C53"
                    label="Nome socio"
                    value={state.datiSimulazioniSrl.C53}
                    className={gClasses.textFieldReadOnly}
                    InputLabelProps={{
                        shrink: true,
                        disabled: true
                    }}
                    inputProps={{tabIndex: -1}}
                    margin="normal"
                />
                <SectionSubTitle text="Redditi non provenienti da questa società"></SectionSubTitle>
                <NumberField
                    name="E133"
                    label="Pensione"
                    value={state.datiSimulazioniSrl.E133}
                    className={gClasses.textField}
                    onChange={handleChange} 
                    onBlur={handleBlur}
                />
                <NumberField
                    name="E134"
                    label="Lav. dipendente e assim."
                    value={state.datiSimulazioniSrl.E134}
                    className={gClasses.textField}
                    onChange={handleChange} 
                    onBlur={handleBlur}
                />
                <NumberField
                    name="E135"
                    label="Assimilati lav. dipendente"
                    value={state.datiSimulazioniSrl.E135}
                    className={gClasses.textField}
                    onChange={handleChange} 
                    onBlur={handleBlur}
                />
                <NumberField
                    name="E136"
                    label="Impr. minore/ Lav. auton."
                    value={state.datiSimulazioniSrl.E136}
                    className={gClasses.textField}
                    onChange={handleChange} 
                    onBlur={handleBlur}
                />
                <NumberField
                    name="E137"
                    label="Diversi lettere i) e l)"
                    value={state.datiSimulazioniSrl.E137}
                    className={gClasses.textField}
                    onChange={handleChange} 
                    onBlur={handleBlur}
                />
                <NumberField
                    name="E138"
                    label="Fabbricati locati"
                    value={state.datiSimulazioniSrl.E138}
                    className={gClasses.textField}
                    onChange={handleChange} 
                    onBlur={handleBlur}
                />
                <NumberField
                    name="E139"
                    label="Altri"
                    value={state.datiSimulazioniSrl.E139}
                    className={gClasses.textField}
                    onChange={handleChange} 
                    onBlur={handleBlur}
                />
                <NumberField
                    name="E140"
                    label="Abitazione principale"
                    value={state.datiSimulazioniSrl.E140}
                    className={gClasses.textField}
                    onChange={handleChange} 
                    onBlur={handleBlur}
                />
                <NumberField
                    name="E142"
                    label="Redditi a cedolare secca"
                    value={state.datiSimulazioniSrl.E142}
                    className={gClasses.textField}
                    onChange={handleChange} 
                    onBlur={handleBlur}
                />
                <SectionSubTitle text="Dati individuali"></SectionSubTitle>
                <Typography variant="h6">Familiari a carico</Typography>
                <Grid container spacing={1} alignItems="flex-start">
                    <Grid item xs={6} md={4}>
                        <FormControlLabel className={gClasses.bottomControlLabel}
                            labelPlacement="end"
                            control={
                                <Checkbox
                                    checked={state.datiSimulazioniSrl.H134}
                                    name='H134'
                                    value={state.datiSimulazioniSrl.H134}
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                    onChange={handleChangeChecked}
                                />
                            }
                            label="Coniuge"
                        />
                    </Grid>
                    <Grid item xs={6} md={4}>
                        <FormControl className={gClasses.formControl}>
                            <InputLabel htmlFor="I134">Figli n.</InputLabel>
                            <Select
                                className={gClasses.select}
                                value={state.datiSimulazioniSrl.J134}
                                inputProps={{ name: 'J134' }}
                                onChange={handleChangeSelect}
                            >
                                <MenuItem value={0}>Non definito</MenuItem>
                                <MenuItem value={1}>1</MenuItem>
                                <MenuItem value={2}>2</MenuItem>
                                <MenuItem value={3}>3</MenuItem>
                                <MenuItem value={4}>4</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6} md={4}>
                        <FormControl className={gClasses.formControl}>
                            <InputLabel htmlFor="K134">%</InputLabel>
                            <Select
                                className={gClasses.select}
                                value={state.datiSimulazioniSrl.L134}
                                inputProps={{ name: 'L134' }}
                                onChange={handleChangeSelect}
                            >
                                <MenuItem value={0}>Non definito</MenuItem>
                                <MenuItem value={50}>50%</MenuItem>
                                <MenuItem value={100}>100%</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container spacing={1} alignItems="flex-end">
                    <Grid item xs={6} md={4}>
                        <NumberField
                            name="L136"
                            label="Oneri deducibili"
                            value={state.datiSimulazioniSrl.L136}
                            className={gClasses.textField}
                            onChange={handleChange} onBlur={handleBlur}
                            tooltip="Oneri deducibili diversi dai contributi IVS"
                        />
                    </Grid>
                    <Grid item xs={6} md={4}>
                        <NumberField
                            name="L137"
                            label="Detrazioni per oneri e altre detrazioni"
                            value={state.datiSimulazioniSrl.L137}
                            className={gClasses.textField}
                            onChange={handleChange} onBlur={handleBlur}
                        />
                    </Grid>
                    <Grid item xs={6} md={4}>
                        <FormControl className={gClasses.formControl}>
                            <InputLabel htmlFor="K135">Aliquota Gestione Separata</InputLabel>
                            <Select
                                className={gClasses.select}
                                value={state.datiSimulazioniSrl.N135}
                                onChange={handleChangeSelect}
                                inputProps={{ name: 'N135', id: 'N135' }}
                            >
                                <MenuItem value={0}>Non definito</MenuItem>
                                <MenuItem value={ALIQUOTA_GESTIONE_SEPARATA.perc_1}>{ALIQUOTA_GESTIONE_SEPARATA.perc_1}%</MenuItem>
                                <MenuItem value={ALIQUOTA_GESTIONE_SEPARATA.perc_2}>{ALIQUOTA_GESTIONE_SEPARATA.perc_2}%</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container spacing={1} alignItems="flex-end">
                    <Grid item xs={6} md={4}>
                        <FormControlLabel className={gClasses.bottomControlLabel}
                            labelPlacement="end"
                            control={
                                <Checkbox
                                    checked={state.datiSimulazioniSrl.J139}
                                    name='J139'
                                    value={state.datiSimulazioniSrl.J139}
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                    onChange={handleChangeChecked}
                                />
                            }
                            label="Soggetto a contribuzione IVS"
                        />
                    </Grid>
                    <Grid item xs={6} md={4}>
                        <NumberField
                            name="J140"
                            label="Ulteriori redditi d'impresa per IVS"
                            value={state.datiSimulazioniSrl.J140}
                            className={gClasses.textField}
                            onChange={handleChange} onBlur={handleBlur}
                        />
                    </Grid>
                    <Grid item xs={6} md={4}>
                        <FormControl className={gClasses.formControl}>
                            <InputLabel htmlFor="K139">Artig./Comm.</InputLabel>
                            <Select
                                className={gClasses.select}
                                value={state.datiSimulazioniSrl.M139}
                                onChange={handleChangeSelect}
                                inputProps={{ name: 'M139', id: 'M139' }}
                            >
                                <MenuItem value={"Non definito"}>Non definito</MenuItem>
                                <MenuItem value={ARTIG_COMM.value_1}>{ARTIG_COMM.desc_1}</MenuItem>
                                <MenuItem value={ARTIG_COMM.value_2}>{ARTIG_COMM.desc_2}</MenuItem>
                                <MenuItem value={ARTIG_COMM.value_3}>{ARTIG_COMM.desc_3}</MenuItem>
                                <MenuItem value={ARTIG_COMM.value_4}>{ARTIG_COMM.desc_4}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container spacing={1} alignItems="flex-end">
                    <Grid item xs={6} md={4}>
                        <FormControl className={gClasses.formControl}>
                            <InputLabel htmlFor="G141">Regione di residenza</InputLabel>
                            <Select
                                className={gClasses.select}
                                value={state.datiSimulazioniSrl.J141}
                                inputProps={{ name: 'J141', id: 'J141' }}
                                onChange={handleChangeSelect}
                            >
                                <MenuItem value={0}>Non definito</MenuItem>
                                {regioni.map(regione => (
                                    <MenuItem key={regione.codice} value={regione.codice}>{regione.descrizione}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6} md={4}>
                        <FormControl className={gClasses.formControl}>
                            <InputLabel htmlFor="K141">Add. Com. Irpef</InputLabel>
                            <Select
                                className={gClasses.select}
                                value={state.datiSimulazioniSrl.M141}
                                inputProps={{ name: 'M141' }}
                                onChange={handleChangeSelect}
                            >
                                <MenuItem value={ADD_COM_IRPEF.perc_1}>{ADD_COM_IRPEF.perc_1}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_2}>{ADD_COM_IRPEF.perc_2}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_3}>{ADD_COM_IRPEF.perc_3}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_4}>{ADD_COM_IRPEF.perc_4}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_5}>{ADD_COM_IRPEF.perc_5}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_6}>{ADD_COM_IRPEF.perc_6}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_7}>{ADD_COM_IRPEF.perc_7}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_8}>{ADD_COM_IRPEF.perc_8}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_9}>{ADD_COM_IRPEF.perc_9}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_10}>{ADD_COM_IRPEF.perc_10}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_11}>{ADD_COM_IRPEF.perc_11}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_12}>{ADD_COM_IRPEF.perc_12}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_13}>{ADD_COM_IRPEF.perc_13}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_14}>{ADD_COM_IRPEF.perc_14}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_15}>{ADD_COM_IRPEF.perc_15}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_16}>{ADD_COM_IRPEF.perc_16}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_17}>{ADD_COM_IRPEF.perc_17}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_18}>{ADD_COM_IRPEF.perc_18}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_19}>{ADD_COM_IRPEF.perc_19}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_20}>{ADD_COM_IRPEF.perc_20}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_21}>{ADD_COM_IRPEF.perc_21}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_22}>{ADD_COM_IRPEF.perc_22}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_23}>{ADD_COM_IRPEF.perc_23}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_24}>{ADD_COM_IRPEF.perc_24}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_25}>{ADD_COM_IRPEF.perc_25}%</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </Paper>
            <Divider></Divider>
            <Paper className={gClasses.mainPaper}>
                <SectionTitle text="3° Socio"></SectionTitle>
                <TextField
                    name="C54"
                    label="Nome socio"
                    value={state.datiSimulazioniSrl.C54}
                    className={gClasses.textFieldReadOnly}
                    InputLabelProps={{
                        shrink: true,
                        disabled: true
                    }}
                    inputProps={{tabIndex: -1}}
                    margin="normal"
                />
                <SectionSubTitle text="Redditi non provenienti da questa società"></SectionSubTitle>
                <NumberField
                    name="E147"
                    label="Pensione"
                    value={state.datiSimulazioniSrl.E147}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E148"
                    label="Lav. dipendente e assim."
                    value={state.datiSimulazioniSrl.E148}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E149"
                    label="Assimilati lav. dipendente"
                    value={state.datiSimulazioniSrl.E149}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E150"
                    label="Impr. minore/ Lav. auton."
                    value={state.datiSimulazioniSrl.E150}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E151"
                    label="Diversi lettere i) e l)"
                    value={state.datiSimulazioniSrl.E151}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E152"
                    label="Fabbricati locati"
                    value={state.datiSimulazioniSrl.E152}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E153"
                    label="Altri"
                    value={state.datiSimulazioniSrl.E153}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E154"
                    label="Abitazione principale"
                    value={state.datiSimulazioniSrl.E154}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E156"
                    label="Redditi a cedolare secca"
                    value={state.datiSimulazioniSrl.E156}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <SectionSubTitle text="Dati individuali"></SectionSubTitle>
                <Typography variant="h6">Familiari a carico</Typography>
                <Grid container spacing={1} alignItems="flex-end">
                    <Grid item xs={6} md={4}>
                        <FormControlLabel className={gClasses.bottomControlLabel}
                            labelPlacement="end"
                            control={
                                <Checkbox
                                    checked={state.datiSimulazioniSrl.H148}
                                    name='H148'
                                    value={state.datiSimulazioniSrl.H148}
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                    onChange={handleChangeChecked}
                                />
                            }
                            label="Coniuge"
                        />
                    </Grid>
                    <Grid item xs={6} md={4}>
                        <FormControl className={gClasses.formControl}>
                            <InputLabel htmlFor="I148">Figli n.</InputLabel>
                            <Select
                                className={gClasses.select}
                                value={state.datiSimulazioniSrl.J148}
                                inputProps={{ name: 'J148' }}
                                onChange={handleChangeSelect}
                            >
                                <MenuItem value={0}>Non definito</MenuItem>
                                <MenuItem value={1}>1</MenuItem>
                                <MenuItem value={2}>2</MenuItem>
                                <MenuItem value={3}>3</MenuItem>
                                <MenuItem value={4}>4</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6} md={4}>
                        <FormControl className={gClasses.formControl}>
                            <InputLabel htmlFor="K148">%</InputLabel>
                            <Select
                                className={gClasses.select}
                                value={state.datiSimulazioniSrl.L148}
                                inputProps={{ name: 'L148' }}
                                onChange={handleChangeSelect}
                            >
                                <MenuItem value={0}>Non definito</MenuItem>
                                <MenuItem value={50}>50%</MenuItem>
                                <MenuItem value={100}>100%</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container spacing={1} alignItems="flex-end">
                    <Grid item xs={6} md={4}>
                        <NumberField
                            name="L150"
                            label="Oneri deducibili"
                            value={state.datiSimulazioniSrl.L150}
                            className={gClasses.textField}
                            onChange={handleChange} onBlur={handleBlur}
                            tooltip="Oneri deducibili diversi dai contributi IVS"
                        />
                    </Grid>
                    <Grid item xs={6} md={4}>
                        <NumberField
                            name="L151"
                            label="Detrazioni per oneri e altre detrazioni"
                            value={state.datiSimulazioniSrl.L151}
                            className={gClasses.textField}
                            onChange={handleChange} onBlur={handleBlur}
                        />
                    </Grid>
                    <Grid item xs={6} md={4}>
                        <FormControl className={gClasses.formControl}>
                            <InputLabel htmlFor="K149">Aliquota Gestione Separata</InputLabel>
                            <Select
                                className={gClasses.select}
                                value={state.datiSimulazioniSrl.N149}
                                onChange={handleChangeSelect}
                                inputProps={{ name: 'N149', id: 'N149' }}
                            >
                                <MenuItem value={0}>Non definito</MenuItem>
                                <MenuItem value={ALIQUOTA_GESTIONE_SEPARATA.perc_1}>{ALIQUOTA_GESTIONE_SEPARATA.perc_1}%</MenuItem>
                                <MenuItem value={ALIQUOTA_GESTIONE_SEPARATA.perc_2}>{ALIQUOTA_GESTIONE_SEPARATA.perc_2}%</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container spacing={1} alignItems="flex-end">
                    <Grid item xs={6} md={4}>
                        <FormControlLabel className={gClasses.bottomControlLabel}
                            labelPlacement="end"
                            control={
                                <Checkbox
                                    checked={state.datiSimulazioniSrl.J153}
                                    name='J153'
                                    value={state.datiSimulazioniSrl.J153}
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                    onChange={handleChangeChecked}
                                />
                            }
                            label="Soggetto a contribuzione IVS"
                        />
                    </Grid>
                    <Grid item xs={6} md={4}>
                        <NumberField
                            name="J154"
                            label="Ulteriori redditi d'impresa per IVS"
                            value={state.datiSimulazioniSrl.J154}
                            className={gClasses.textField}
                            onChange={handleChange} onBlur={handleBlur}
                        />
                    </Grid>
                    <Grid item xs={6} md={4}>
                        <FormControl className={gClasses.formControl}>
                            <InputLabel htmlFor="K153">Artig./Comm.</InputLabel>
                            <Select
                                className={gClasses.select}
                                value={state.datiSimulazioniSrl.M153}
                                onChange={handleChangeSelect}
                                inputProps={{ name: 'M153', id: 'M153' }}
                            >
                                <MenuItem value={"Non definito"}>Non definito</MenuItem>
                                <MenuItem value={ARTIG_COMM.value_1}>{ARTIG_COMM.desc_1}</MenuItem>
                                <MenuItem value={ARTIG_COMM.value_2}>{ARTIG_COMM.desc_2}</MenuItem>
                                <MenuItem value={ARTIG_COMM.value_3}>{ARTIG_COMM.desc_3}</MenuItem>
                                <MenuItem value={ARTIG_COMM.value_4}>{ARTIG_COMM.desc_4}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container spacing={1} alignItems="flex-end">
                    <Grid item xs={6} md={4}>
                        <FormControl className={gClasses.formControl}>
                            <InputLabel htmlFor="G155">Regione di residenza</InputLabel>
                            <Select
                                className={gClasses.select}
                                value={state.datiSimulazioniSrl.J155}
                                inputProps={{ name: 'J155', id: 'J155' }}
                                onChange={handleChangeSelect}
                            >
                                <MenuItem value={0}>Non definito</MenuItem>
                                {regioni.map(regione => (
                                    <MenuItem key={regione.codice} value={regione.codice}>{regione.descrizione}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6} md={4}>
                        <FormControl className={gClasses.formControl}>
                            <InputLabel htmlFor="K155">Add. Com. Irpef</InputLabel>
                            <Select
                                className={gClasses.select}
                                value={state.datiSimulazioniSrl.M155}
                                inputProps={{ name: 'M155' }}
                                onChange={handleChangeSelect}
                            >
                                <MenuItem value={ADD_COM_IRPEF.perc_1}>{ADD_COM_IRPEF.perc_1}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_2}>{ADD_COM_IRPEF.perc_2}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_3}>{ADD_COM_IRPEF.perc_3}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_4}>{ADD_COM_IRPEF.perc_4}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_5}>{ADD_COM_IRPEF.perc_5}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_6}>{ADD_COM_IRPEF.perc_6}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_7}>{ADD_COM_IRPEF.perc_7}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_8}>{ADD_COM_IRPEF.perc_8}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_9}>{ADD_COM_IRPEF.perc_9}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_10}>{ADD_COM_IRPEF.perc_10}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_11}>{ADD_COM_IRPEF.perc_11}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_12}>{ADD_COM_IRPEF.perc_12}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_13}>{ADD_COM_IRPEF.perc_13}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_14}>{ADD_COM_IRPEF.perc_14}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_15}>{ADD_COM_IRPEF.perc_15}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_16}>{ADD_COM_IRPEF.perc_16}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_17}>{ADD_COM_IRPEF.perc_17}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_18}>{ADD_COM_IRPEF.perc_18}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_19}>{ADD_COM_IRPEF.perc_19}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_20}>{ADD_COM_IRPEF.perc_20}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_21}>{ADD_COM_IRPEF.perc_21}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_22}>{ADD_COM_IRPEF.perc_22}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_23}>{ADD_COM_IRPEF.perc_23}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_24}>{ADD_COM_IRPEF.perc_24}%</MenuItem>
                                <MenuItem value={ADD_COM_IRPEF.perc_25}>{ADD_COM_IRPEF.perc_25}%</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </Paper>
            {/* <div>
                <TextField
                    name="C55"
                    label="4)"
                    value={state.datiSimulazioniSrl.C55}
                    className={gClasses.textField}
                    InputLabelProps={{
                        shrink: true,
                        disabled: true
                    }}
                    margin="normal"
                />
                <Typography variant="h6">Redditi non provenienti da questa società</Typography>
                <NumberField
                    name="E161"
                    label="Pensione"
                    value={state.datiSimulazioniSrl.E161}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E162"
                    label="Lav. dipendente e assim."
                    value={state.datiSimulazioniSrl.E162}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E163"
                    label="Assimilati lav. dipendente"
                    value={state.datiSimulazioniSrl.E163}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E164"
                    label="Impr. minore/ Lav. auton."
                    value={state.datiSimulazioniSrl.E164}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E165"
                    label="Diversi lettere i) e l)"
                    value={state.datiSimulazioniSrl.E165}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E166"
                    label="Fabbricati locati"
                    value={state.datiSimulazioniSrl.E166}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E167"
                    label="Altri"
                    value={state.datiSimulazioniSrl.E167}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E168"
                    label="Abitazione principale"
                    value={state.datiSimulazioniSrl.E168}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E170"
                    label="Redditi a cedolare secca"
                    value={state.datiSimulazioniSrl.E170}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <Typography variant="h6">Dati individuali</Typography>
                <Typography variant="h6">Familiari a carico</Typography>
                <FormControlLabel className={gClasses.bottomControlLabel}
                    labelPlacement="end"
                    control={
                        <Checkbox
                        
                            checked={state.datiSimulazioniSrl.H162}
                            name='H162'
                            value={state.datiSimulazioniSrl.H162}
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                            onChange={handleChangeChecked}
                        />
                    }
                    label="Coniuge"
                />
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="I162">Figli n.</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.datiSimulazioniSrl.J162}
                        inputProps={{ name: 'J162' }}
                        onChange={handleChange} onBlur={handleBlur}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        <MenuItem value={1}>1</MenuItem>
                        <MenuItem value={2}>2</MenuItem>
                        <MenuItem value={3}>3</MenuItem>
                        <MenuItem value={4}>4</MenuItem>
                    </Select>
                </FormControl>
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="K162">%</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.datiSimulazioniSrl.L162}
                        inputProps={{ name: 'L162' }}
                        onChange={handleChange} onBlur={handleBlur}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        <MenuItem value={50}>50%</MenuItem>
                        <MenuItem value={100}>100%</MenuItem>
                    </Select>
                </FormControl>
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="K163">Aliquota Gestione Separata</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.datiSimulazioniSrl.N163}
                        onChange={handleChange} onBlur={handleBlur}
                        inputProps={{ name: 'N163', id: 'N163' }}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        <MenuItem value={ALIQUOTA_GESTIONE_SEPARATA.perc_1}>{ALIQUOTA_GESTIONE_SEPARATA.perc_1}%</MenuItem>
                        <MenuItem value={ALIQUOTA_GESTIONE_SEPARATA.perc_2}>{ALIQUOTA_GESTIONE_SEPARATA.perc_2}%</MenuItem>
                    </Select>
                </FormControl>
                <NumberField
                    name="L164"
                    label="Oneri deducibili"
                    value={state.datiSimulazioniSrl.L164}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                    tooltip="Oneri deducibili diversi dai contributi IVS"
                />
                <NumberField
                    name="L165"
                    label="Detrazioni per oneri e altre detrazioni"
                    value={state.datiSimulazioniSrl.L165}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <FormControlLabel className={gClasses.bottomControlLabel}
                    labelPlacement="start"
                    control={
                        <Checkbox
                        
                            checked={state.datiSimulazioniSrl.J167}
                            name='J167'
                            value={state.datiSimulazioniSrl.J167}
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                            onChange={handleChangeChecked}
                        />
                    }
                    label="Soggetto a contribuzione IVS"
                />
                <NumberField
                    name="J168"
                    label="Ulteriori redditi d'impresa per IVS"
                    value={state.datiSimulazioniSrl.J168}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="G169">Regione di residenza</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.datiSimulazioniSrl.J169}
                        inputProps={{ name: 'J169', id: 'J169' }}
                        onChange={handleChange} onBlur={handleBlur}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        {regioni.map(regione => (
                            <MenuItem key={regione.codice} value={regione.codice}>{regione.descrizione}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="K167">Artig./Comm.</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.datiSimulazioniSrl.M167}
                        onChange={handleChange} onBlur={handleBlur}
                        inputProps={{ name: 'M167', id: 'M167' }}
                    >
                        <MenuItem value={"Non definito"}>Non definito</MenuItem>
                        <MenuItem value={ARTIG_COMM.desc_1}>{ARTIG_COMM.desc_1}</MenuItem>
                        <MenuItem value={ARTIG_COMM.desc_2}>{ARTIG_COMM.desc_2}</MenuItem>
                        <MenuItem value={ARTIG_COMM.desc_3}>{ARTIG_COMM.desc_3}</MenuItem>
                        <MenuItem value={ARTIG_COMM.desc_4}>{ARTIG_COMM.desc_4}</MenuItem>
                    </Select>
                </FormControl>
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="K169">Add. Com. Irpef</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.datiSimulazioniSrl.M169}
                        inputProps={{ name: 'M169' }}
                        onChange={handleChange} onBlur={handleBlur}
                    >
                        <MenuItem value={ADD_COM_IRPEF.perc_1}>{ADD_COM_IRPEF.perc_1}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_2}>{ADD_COM_IRPEF.perc_2}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_3}>{ADD_COM_IRPEF.perc_3}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_4}>{ADD_COM_IRPEF.perc_4}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_5}>{ADD_COM_IRPEF.perc_5}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_6}>{ADD_COM_IRPEF.perc_6}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_7}>{ADD_COM_IRPEF.perc_7}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_8}>{ADD_COM_IRPEF.perc_8}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_9}>{ADD_COM_IRPEF.perc_9}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_10}>{ADD_COM_IRPEF.perc_10}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_11}>{ADD_COM_IRPEF.perc_11}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_12}>{ADD_COM_IRPEF.perc_12}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_13}>{ADD_COM_IRPEF.perc_13}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_14}>{ADD_COM_IRPEF.perc_14}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_15}>{ADD_COM_IRPEF.perc_15}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_16}>{ADD_COM_IRPEF.perc_16}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_17}>{ADD_COM_IRPEF.perc_17}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_18}>{ADD_COM_IRPEF.perc_18}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_19}>{ADD_COM_IRPEF.perc_19}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_20}>{ADD_COM_IRPEF.perc_20}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_21}>{ADD_COM_IRPEF.perc_21}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_22}>{ADD_COM_IRPEF.perc_22}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_23}>{ADD_COM_IRPEF.perc_23}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_24}>{ADD_COM_IRPEF.perc_24}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_25}>{ADD_COM_IRPEF.perc_25}%</MenuItem>
                    </Select>
                </FormControl>
            </div>
            <div>
                <TextField
                    name="C56"
                    label="5)"
                    value={state.datiSimulazioniSrl.C56}
                    className={gClasses.textField}
                    InputLabelProps={{
                        shrink: true,
                        disabled: true
                    }}
                    margin="normal"
                />
                <Typography variant="h6">Redditi non provenienti da questa società</Typography>
                <NumberField
                    name="E176"
                    label="Pensione"
                    value={state.datiSimulazioniSrl.E176}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E177"
                    label="Lav. dipendente e assim."
                    value={state.datiSimulazioniSrl.E177}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E178"
                    label="Assimilati lav. dipendente"
                    value={state.datiSimulazioniSrl.E178}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E179"
                    label="Impr. minore/ Lav. auton."
                    value={state.datiSimulazioniSrl.E179}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E180"
                    label="Diversi lettere i) e l)"
                    value={state.datiSimulazioniSrl.E180}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E181"
                    label="Fabbricati locati"
                    value={state.datiSimulazioniSrl.E181}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E182"
                    label="Altri"
                    value={state.datiSimulazioniSrl.E182}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E183"
                    label="Abitazione principale"
                    value={state.datiSimulazioniSrl.E183}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E185"
                    label="Redditi a cedolare secca"
                    value={state.datiSimulazioniSrl.E185}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <Typography variant="h6">Dati individuali</Typography>
                <Typography variant="h6">Familiari a carico</Typography>
                <FormControlLabel className={gClasses.bottomControlLabel}
                    labelPlacement="end"
                    control={
                        <Checkbox
                        
                            checked={state.datiSimulazioniSrl.H177}
                            name='H177'
                            value={state.datiSimulazioniSrl.H177}
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                            onChange={handleChangeChecked}
                        />
                    }
                    label="Coniuge"
                />
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="I177">Figli n.</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.datiSimulazioniSrl.J177}
                        inputProps={{ name: 'J177' }}
                        onChange={handleChange} onBlur={handleBlur}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        <MenuItem value={1}>1</MenuItem>
                        <MenuItem value={2}>2</MenuItem>
                        <MenuItem value={3}>3</MenuItem>
                        <MenuItem value={4}>4</MenuItem>
                    </Select>
                </FormControl>
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="K177">%</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.datiSimulazioniSrl.L177}
                        inputProps={{ name: 'L177' }}
                        onChange={handleChange} onBlur={handleBlur}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        <MenuItem value={50}>50%</MenuItem>
                        <MenuItem value={100}>100%</MenuItem>
                    </Select>
                </FormControl>
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="K178">Aliquota Gestione Separata</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.datiSimulazioniSrl.N178}
                        onChange={handleChange} onBlur={handleBlur}
                        inputProps={{ name: 'N178', id: 'N178' }}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        <MenuItem value={ALIQUOTA_GESTIONE_SEPARATA.perc_1}>{ALIQUOTA_GESTIONE_SEPARATA.perc_1}%</MenuItem>
                        <MenuItem value={ALIQUOTA_GESTIONE_SEPARATA.perc_2}>{ALIQUOTA_GESTIONE_SEPARATA.perc_2}%</MenuItem>
                    </Select>
                </FormControl>
                <NumberField
                    name="L179"
                    label="Oneri deducibili"
                    value={state.datiSimulazioniSrl.L179}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                    tooltip="Oneri deducibili diversi dai contributi IVS"
                />
                <NumberField
                    name="L180"
                    label="Detrazioni per oneri e altre detrazioni"
                    value={state.datiSimulazioniSrl.L180}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <FormControlLabel className={gClasses.bottomControlLabel}
                    labelPlacement="start"
                    control={
                        <
                        
                            checked={state.datiSimulazioniSrl.J182}
                            name='J182'
                            value={state.datiSimulazioniSrl.J182}
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                            onChange={handleChangeChecked}
                        />
                    }
                    label="Soggetto a contribuzione IVS"
                />
                <NumberField
                    name="J183"
                    label="Ulteriori redditi d'impresa per IVS"
                    value={state.datiSimulazioniSrl.J183}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="G184">Regione di residenza</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.datiSimulazioniSrl.J184}
                        inputProps={{ name: 'J184', id: 'J184' }}
                        onChange={handleChange} onBlur={handleBlur}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        {regioni.map(regione => (
                            <MenuItem key={regione.codice} value={regione.codice}>{regione.descrizione}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="K182">Artig./Comm.</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.datiSimulazioniSrl.M182}
                        onChange={handleChange} onBlur={handleBlur}
                        inputProps={{ name: 'M182', id: 'M182' }}
                    >
                        <MenuItem value={"Non definito"}>Non definito</MenuItem>
                        <MenuItem value={ARTIG_COMM.desc_1}>{ARTIG_COMM.desc_1}</MenuItem>
                        <MenuItem value={ARTIG_COMM.desc_2}>{ARTIG_COMM.desc_2}</MenuItem>
                        <MenuItem value={ARTIG_COMM.desc_3}>{ARTIG_COMM.desc_3}</MenuItem>
                        <MenuItem value={ARTIG_COMM.desc_4}>{ARTIG_COMM.desc_4}</MenuItem>
                    </Select>
                </FormControl>
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="K184">Add. Com. Irpef</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.datiSimulazioniSrl.M184}
                        inputProps={{ name: 'M184' }}
                        onChange={handleChange} onBlur={handleBlur}
                    >
                        <MenuItem value={ADD_COM_IRPEF.perc_1}>{ADD_COM_IRPEF.perc_1}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_2}>{ADD_COM_IRPEF.perc_2}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_3}>{ADD_COM_IRPEF.perc_3}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_4}>{ADD_COM_IRPEF.perc_4}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_5}>{ADD_COM_IRPEF.perc_5}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_6}>{ADD_COM_IRPEF.perc_6}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_7}>{ADD_COM_IRPEF.perc_7}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_8}>{ADD_COM_IRPEF.perc_8}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_9}>{ADD_COM_IRPEF.perc_9}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_10}>{ADD_COM_IRPEF.perc_10}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_11}>{ADD_COM_IRPEF.perc_11}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_12}>{ADD_COM_IRPEF.perc_12}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_13}>{ADD_COM_IRPEF.perc_13}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_14}>{ADD_COM_IRPEF.perc_14}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_15}>{ADD_COM_IRPEF.perc_15}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_16}>{ADD_COM_IRPEF.perc_16}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_17}>{ADD_COM_IRPEF.perc_17}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_18}>{ADD_COM_IRPEF.perc_18}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_19}>{ADD_COM_IRPEF.perc_19}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_20}>{ADD_COM_IRPEF.perc_20}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_21}>{ADD_COM_IRPEF.perc_21}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_22}>{ADD_COM_IRPEF.perc_22}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_23}>{ADD_COM_IRPEF.perc_23}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_24}>{ADD_COM_IRPEF.perc_24}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_25}>{ADD_COM_IRPEF.perc_25}%</MenuItem>
                    </Select>
                </FormControl>
            </div>
            <div>
                <TextField
                    name="C57"
                    label="6)"
                    value={state.datiSimulazioniSrl.C57}
                    className={gClasses.textField}
                    InputLabelProps={{
                        shrink: true,
                        disabled: true
                    }}
                    margin="normal"
                />
                <Typography variant="h6">Redditi non provenienti da questa società</Typography>
                <NumberField
                    name="E190"
                    label="Pensione"
                    value={state.datiSimulazioniSrl.E190}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E191"
                    label="Lav. dipendente e assim."
                    value={state.datiSimulazioniSrl.E191}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E192"
                    label="Assimilati lav. dipendente"
                    value={state.datiSimulazioniSrl.E192}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E193"
                    label="Impr. minore/ Lav. auton."
                    value={state.datiSimulazioniSrl.E193}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E194"
                    label="Diversi lettere i) e l)"
                    value={state.datiSimulazioniSrl.E194}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E195"
                    label="Fabbricati locati"
                    value={state.datiSimulazioniSrl.E195}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E196"
                    label="Altri"
                    value={state.datiSimulazioniSrl.E196}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E197"
                    label="Abitazione principale"
                    value={state.datiSimulazioniSrl.E197}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <NumberField
                    name="E199"
                    label="Redditi a cedolare secca"
                    value={state.datiSimulazioniSrl.E199}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <Typography variant="h6">Dati individuali</Typography>
                <Typography variant="h6">Familiari a carico</Typography>
                <FormControlLabel className={gClasses.bottomControlLabel}
                    labelPlacement="end"
                    control={
                        <Checkbox
                        
                            checked={state.datiSimulazioniSrl.H191}
                            name='H191'
                            value={state.datiSimulazioniSrl.H191}
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                            onChange={handleChangeChecked}
                        />
                    }
                    label="Coniuge"
                />
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="I191">Figli n.</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.datiSimulazioniSrl.J191}
                        inputProps={{ name: 'J191' }}
                        onChange={handleChange} onBlur={handleBlur}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        <MenuItem value={1}>1</MenuItem>
                        <MenuItem value={2}>2</MenuItem>
                        <MenuItem value={3}>3</MenuItem>
                        <MenuItem value={4}>4</MenuItem>
                    </Select>
                </FormControl>
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="K191">%</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.datiSimulazioniSrl.L191}
                        inputProps={{ name: 'L191' }}
                        onChange={handleChange} onBlur={handleBlur}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        <MenuItem value={50}>50%</MenuItem>
                        <MenuItem value={100}>100%</MenuItem>
                    </Select>
                </FormControl>
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="K192">Aliquota Gestione Separata</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.datiSimulazioniSrl.N192}
                        onChange={handleChange} onBlur={handleBlur}
                        inputProps={{ name: 'N192', id: 'N192' }}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        <MenuItem value={ALIQUOTA_GESTIONE_SEPARATA.perc_1}>{ALIQUOTA_GESTIONE_SEPARATA.perc_1}%</MenuItem>
                        <MenuItem value={ALIQUOTA_GESTIONE_SEPARATA.perc_2}>{ALIQUOTA_GESTIONE_SEPARATA.perc_2}%</MenuItem>
                    </Select>
                </FormControl>
                <NumberField
                    name="L193"
                    label="Oneri deducibili"
                    value={state.datiSimulazioniSrl.L193}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                    tooltip="Oneri deducibili diversi dai contributi IVS"
                />
                <NumberField
                    name="L194"
                    label="Detrazioni per oneri e altre detrazioni"
                    value={state.datiSimulazioniSrl.L194}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <FormControlLabel className={gClasses.bottomControlLabel}
                    labelPlacement="start"
                    control={
                        <Checkbox
                        
                            checked={state.datiSimulazioniSrl.J196}
                            name='J196'
                            value={state.datiSimulazioniSrl.J196}
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                            onChange={handleChangeChecked}
                        />
                    }
                    label="Soggetto a contribuzione IVS"
                />
                <NumberField
                    name="J197"
                    label="Ulteriori redditi d'impresa per IVS"
                    value={state.datiSimulazioniSrl.J197}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="G198">Regione di residenza</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.datiSimulazioniSrl.J198}
                        inputProps={{ name: 'J198', id: 'J198' }}
                        onChange={handleChange} onBlur={handleBlur}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        {regioni.map(regione => (
                            <MenuItem key={regione.codice} value={regione.codice}>{regione.descrizione}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="K196">Artig./Comm.</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.datiSimulazioniSrl.M196}
                        onChange={handleChange} onBlur={handleBlur}
                        inputProps={{ name: 'M196', id: 'M196' }}
                    >
                        <MenuItem value={"Non definito"}>Non definito</MenuItem>
                        <MenuItem value={ARTIG_COMM.desc_1}>{ARTIG_COMM.desc_1}</MenuItem>
                        <MenuItem value={ARTIG_COMM.desc_2}>{ARTIG_COMM.desc_2}</MenuItem>
                        <MenuItem value={ARTIG_COMM.desc_3}>{ARTIG_COMM.desc_3}</MenuItem>
                        <MenuItem value={ARTIG_COMM.desc_4}>{ARTIG_COMM.desc_4}</MenuItem>
                    </Select>
                </FormControl>
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="K198">Add. Com. Irpef</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.datiSimulazioniSrl.M198}
                        inputProps={{ name: 'M198' }}
                        onChange={handleChange} onBlur={handleBlur}
                    >
                        <MenuItem value={ADD_COM_IRPEF.perc_1}>{ADD_COM_IRPEF.perc_1}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_2}>{ADD_COM_IRPEF.perc_2}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_3}>{ADD_COM_IRPEF.perc_3}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_4}>{ADD_COM_IRPEF.perc_4}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_5}>{ADD_COM_IRPEF.perc_5}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_6}>{ADD_COM_IRPEF.perc_6}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_7}>{ADD_COM_IRPEF.perc_7}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_8}>{ADD_COM_IRPEF.perc_8}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_9}>{ADD_COM_IRPEF.perc_9}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_10}>{ADD_COM_IRPEF.perc_10}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_11}>{ADD_COM_IRPEF.perc_11}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_12}>{ADD_COM_IRPEF.perc_12}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_13}>{ADD_COM_IRPEF.perc_13}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_14}>{ADD_COM_IRPEF.perc_14}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_15}>{ADD_COM_IRPEF.perc_15}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_16}>{ADD_COM_IRPEF.perc_16}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_17}>{ADD_COM_IRPEF.perc_17}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_18}>{ADD_COM_IRPEF.perc_18}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_19}>{ADD_COM_IRPEF.perc_19}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_20}>{ADD_COM_IRPEF.perc_20}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_21}>{ADD_COM_IRPEF.perc_21}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_22}>{ADD_COM_IRPEF.perc_22}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_23}>{ADD_COM_IRPEF.perc_23}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_24}>{ADD_COM_IRPEF.perc_24}%</MenuItem>
                        <MenuItem value={ADD_COM_IRPEF.perc_25}>{ADD_COM_IRPEF.perc_25}%</MenuItem>
                    </Select>
                </FormControl>
            </div> */}
        </React.Fragment >
    );
}